import React from "react";
import TopBanner from "../components/TopBanner";
import styled from "styled-components";
import Form from "../components/Form";

const BusinessInsurance = () => {
  return (
    <>
      <TopBanner content={"Business Insurance"} />
      <ContentWrapper>
        <div className="text-content">
          <h3>Shield Your Business. Secure Your Growth.</h3>
          <p>
            Every business comes with its own share of financial risks, losses,
            and hazards that may harm your business. Since risks are an
            unavoidable part of a business, you may secure your business against
            certain risks by buying business insurance. You simply have to pay a
            premium for a specified tenure to insure your business for a sum of
            money (sum assured).
          </p>
          <p>
            Business insurance is a type of insurance that allows the
            policyholder to secure his/her business against natural calamities,
            thefts, loss of income, death or injury of employees,damage/loss of
            equipment, or any form of judicial proceedings.
          </p>

          <h3>Types of business insurance:</h3>
          <ol>
            <li>Professional liability insurance</li>
            <li>Home-based business insurance</li>
            <li>Product liability insurance</li>
            <li>Vehicle insurance</li>
            <li>Property insurance</li>
            <li>Worker’s compensation</li>
            <li>Business interruption insurance</li>
          </ol>

          <h3>Who can purchase business insurance?</h3>
          <p>
            Business insurances cover all sectors and business types including
            start-ups. some of the major buyers of business insurance are as
            follows:
          </p>
          <ol>
            <li>Restaurants</li>
            <li>Retail stores and wholesalers</li>
            <li>Trading companies</li>
            <li>Distributors and contractors</li>
            <li>Production units</li>
          </ol>
        </div>
        <Form />
      </ContentWrapper>
    </>
  );
};

export default BusinessInsurance;

export const ContentWrapper = styled.div`
  display: flex;
  padding: 100px;
  gap: 20px;

  .text-content {
    width: 50%;
    p,
    ul,
    li {
      font-size: 1.1rem;
      line-height: 1.6;
      color: #333;
      text-align: left;
    }
  }

  h3 {
    color: black;
  }

  @media (max-width: 900px) {
    flex-direction: column;
    padding: 30px;

    .text-content {
      width: 100%;
    }
  }
`;
